import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section className="relative bg-gradient-to-b from-slate-900 via-slate-800/95 to-slate-900 py-24 sm:py-32 overflow-hidden">
      {/* Animated gradient blob */}
      <div 
        className="absolute top-20 right-10 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-pulse"
        style={{
          transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.01}px)`,
        }}
      />
      <div className="absolute bottom-20 left-10 w-72 h-72 bg-teal-600/15 rounded-full blur-3xl animate-pulse delay-1000" />

      {/* Geometric shapes */}
      <div className="absolute top-0 right-0 w-1 sm:w-1.5 h-24 bg-teal-500 rounded-l-full opacity-80 animate-[slideDown_1s_ease-out]" />
      <div className="absolute bottom-20 left-0 w-32 h-px bg-gradient-to-left from-teal-500/50 to-transparent" />
      
      {/* Floating dots */}
      <div className="absolute top-32 left-1/4 w-2 h-2 bg-teal-400 rounded-full opacity-60 animate-[float_3s_ease-in-out_infinite]" />
      <div className="absolute top-48 right-1/3 w-1.5 h-1.5 bg-teal-500 rounded-full opacity-50 animate-[float_4s_ease-in-out_infinite_1s]" />
      <div className="absolute bottom-32 left-1/3 w-2 h-2 bg-teal-400 rounded-full opacity-40 animate-[float_3.5s_ease-in-out_infinite_0.5s]" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <div className="mb-6 flex justify-center animate-[fadeInUp_0.8s_ease-out]">
          <div className="relative group">
            <img
              src="/LLogo.png"
              alt="استودیو آلتو"
              className="h-16 sm:h-20 w-auto opacity-90 group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-teal-500/20 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10" />
          </div>
        </div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight max-w-2xl mx-auto animate-[fadeInUp_0.8s_ease-out_0.2s_both]">
          طراحی و توسعه وب برای{' '}
          <span className="relative inline-block">
            <span className="relative z-10 bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              کسب‌وکار شما
            </span>
            <span className="absolute bottom-0 right-0 w-full h-2 bg-teal-500/40 -z-0 animate-[underline_1s_ease-out_1s_both]" />
          </span>
        </h1>
        <p className="text-slate-400 mt-6 text-lg max-w-xl mx-auto leading-relaxed animate-[fadeInUp_0.8s_ease-out_0.4s_both]">
          از ایده تا اجرا — با استانداردهای روز و تیم متخصص.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.6s_both]">
          <a
            href="https://wa.me/09134378347"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3.5 rounded-lg text-sm font-medium hover:bg-teal-700 shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 hover:-translate-y-0.5 transition-all duration-200 overflow-hidden"
          >
            <span className="relative z-10">درخواست مشاوره</span>
            <svg className="w-4 h-4 relative z-10 group-hover:translate-x-[-2px] transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-600 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-300" />
          </a>
          <button
            type="button"
            onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
            className="group inline-flex items-center gap-2 text-slate-300 hover:text-teal-400 font-medium text-sm px-4 py-2 rounded-lg border border-slate-600 hover:border-teal-500 transition-all hover:bg-slate-800"
          >
            نمونه‌کارها
            <svg className="w-4 h-4 group-hover:translate-y-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            height: 0;
          }
          to {
            height: 6rem;
          }
        }
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        @keyframes underline {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;
